import React from 'react'

import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import Button from 'components/atoms/Button'
import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'

import PeluangMessage from './PeluangMessage.json'

const PeluangTimer = () => {
  const content = () => {
    const today = new Date()
    if (isAfter(today, new Date(2021, 2, 8)) && isBefore(today, new Date(2021, 2, 18))) {
      return PeluangMessage.pre_test
    }
    if (isAfter(today, new Date(2021, 2, 18)) && isBefore(today, new Date(2021, 2, 24))) {
      return PeluangMessage.test
    }
    if (isAfter(today, new Date(2021, 2, 24)) && isBefore(today, new Date(2021, 3, 3))) {
      return PeluangMessage.after_test
    }
    return PeluangMessage.default
  }
  return (
    <div className="peluang-timer">
      <SectionContainer
        backgroundColor="transparent"
      >
        <Container>
          <div className="peluang-timer__wrapper">
            {content().messages.map((msg, idx) => (
              <Typography component="p" variant="subbody" className="peluang-timer__text" key={`msg-${idx}`}>
                {msg}
              </Typography>
            ))}
            <div className="peluang-timer__pre-order">
              <Button tag="a" variant="default" href={content().link} target="_blank" rel="noopener" className="peluang-timer__btn">
                {content().btnText}
              </Button>
            </div>
          </div>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .peluang-timer {
            text-align: center;
            padding: 64px 0;
            :global(&__text) {
              color: #0c2846 !important;
            }
            &__wrapper {
              position: relative;
            }
            &__notification {
              color: #FB627A !important;
            }
            &__pre-order {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            :global(&__btn) {
              font-weight: bold;
              padding: 16px 42px;
              border-radius: 8px;
              margin-top: 24px;
            }
            :global(&__email) {
              padding: 22px 16px !important;
              width: 500px !important;
              border-top-left-radius: 8px !important;
              border-bottom-left-radius: 8px !important;
              border-top-right-radius: 0px !important;
              border-bottom-right-radius: 0px !important;
              box-shadow: 0 8px 16px 0 rgba(30, 63, 107, 0.15) !important;
              border: solid 1px #bed2e8 !important;
            }
            :global(&__loader) {
              width: 50px;
              margin-top: 16px;
            }
            @media screen and (max-width: 767px) {
              padding: 40px 0 0 0;
              :global(&__plane) {
                display: none;
              }
              &__pre-order {
                flex-direction: column;
              }
              :global(&__email) {
                padding: 16px !important;
                width: 100% !important;
                border-top-left-radius: 8px !important;
                border-top-right-radius: 8px !important;
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
              }
            }

          }
        `}
      </style>
      <style jsx global>
        {`
          .peluang-timer__plane {
            animation: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95) 0s infinite alternate none running planeAnimation;
            transform: translateY(-15px);
            position: absolute;
            &.right {
              right: -8%;
            }
            &.left {
              bottom: 17%;
              left: -5%;
            }
          }
          @keyframes planeAnimation {
            0% {
              transform: translateY(-15px);
            }
            100% {
              transform: translateY(15px);
            }
          }
        `}
      </style>
    </div>
  )
}

export default PeluangTimer
